const setScrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

export default setScrollTop;
